import AppBar from '@mui/material/AppBar';
import clsx from 'clsx';
import { useMsal } from '@azure/msal-react';
import { styled } from '@mui/material/styles';
import { getFullName } from 'auth/account';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CurrentUser from 'auth/currentUser';

const PREFIX = 'UserNavbarHeader';

const classes = {
  root: `${PREFIX}-root`,
  avatar: `${PREFIX}-avatar`,
  transparent: `${PREFIX}-transparent`,
};

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  justifyContent: 'center',
  position: 'relative',
  marginBottom: 32,
  paddingTop: 24,
  paddingBottom: 64,
  display: 'flex',
  flexDirection: 'column',
  [`&.${classes.transparent}`]: {
    background: 'transparent',
  },
  '& > *': {
    maxWidth: '90%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  '&.user': {
    '& .username, & .email': {
      minHeight: 20,
      whiteSpace: 'noWrap',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut,
      }),
    },
    '& .username': {
      fontSize: 16,
    },
    '& .email': {
      marginTop: 8,
      fontSize: 13,
      opacity: 0.5,
    },
  },
  [`& .${classes.avatar}`]: {
    zIndex: 100,
    position: 'absolute',
    width: 72,
    height: 72,
    bottom: -36,
    fontSize: 70,
    color: 'white',
    padding: 8,
    background: '#121212',
    boxSizing: 'content-box',
    left: '50%',
    transform: 'translateX(-50%)',
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
    '& > img': {
      borderRadius: '50%',
    },
  },
}));

interface Props {
  open: boolean;
  color?: 'primary' | 'secondary';
  transparent?: boolean;
}

function UserNavbarHeader(props: Props): JSX.Element {
  const { accounts } = useMsal();
  const photoUrl = '';
  const name = getFullName(accounts[0]);
  const { open, color = 'primary', transparent } = props;
  const companyName = CurrentUser.getInstance().getCompanyName();
  if (!open) {
    return <></>;
  }
  return (
    <StyledAppBar
      position="static"
      color={color}
      elevation={0}
      className={clsx('user relative items-center z-0', transparent ? classes.transparent : '')}
    >
      <Typography className="username" color="inherit">
        {name || 'Unknown'}
      </Typography>
      {companyName && (
        <Typography className="company" color="inherit">
          {companyName || ''}
        </Typography>
      )}
      {photoUrl ? (
        <Avatar className={classes.avatar} alt="user photo" src={photoUrl} />
      ) : (
        <Avatar className={classes.avatar}>
          <AccountCircleIcon color="inherit" fontSize="inherit" />
        </Avatar>
      )}
    </StyledAppBar>
  );
}

export default UserNavbarHeader;
